/* eslint-disable complexity */
import React from "react";

import { Button, Tabs } from "antd";
import debounce from "lodash/debounce";
import JEditor from "../..";
import Quill from "quill";
import CursorPopover from "../CursorPopover";
import "./index.less";
import { Employee, Session } from "@/types/chat";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import { changeEgovUrl } from "@/utils/tools";
import { extraConvertEmployeeToString, getUnitTitleInfo, isShowAlias } from "@/utils/chat/message";
import { Avatar } from "@/baseComponents/Avatar";
import CheckBox from "@/baseComponents/Checkbox";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import Bus from "@/utils/bus";
import { isFocusEnv } from "@/utils";
// import IconFont from "@/components/icon";
import unitAvatar from "@/assets/images/unitAvatar.png";
import deptAvatar from "@/assets/images/deptAvatar.png";
import titleAvatar from "@/assets/images/titleAvatar.png";
import { CrossTag } from "@/components/Tags";
import { tagsNode } from "@/components/AddressBook/common";
export interface MentionUserPluginProps {
  editor: JEditor | any;
  members: Partial<Employee>[];
  handleSearch: (input: string) => Partial<Employee>[];
  t: any;
  onVisibleChange?: (visible: boolean) => void;
  selectedSession: Session;
  groupMemberSessionId: string;
  isQuillModal?: boolean;
}

export interface MentionUserPluginState {
  users: Partial<Employee>[];
  selected: string[];
  text: string;
  visible: boolean;
  onvisible: boolean;
  multipleUserSelect: boolean;
  focusUser: any;
  activeKey: string;
}
class MentionUserPlugin extends React.Component<
  MentionUserPluginProps & ChatState,
  MentionUserPluginState
> {
  ref_div: React.RefObject<HTMLDivElement> = React.createRef();
  curRef: CursorPopover | null = null;
  constructor(props: any) {
    super(props);
    this.onTextInput = debounce(this.onTextInput, 300);
    this.state = {
      users: props.members.slice(0, 30),
      selected: [],
      text: "",
      visible: false,
      multipleUserSelect: true,
      onvisible: false,
      focusUser: {},
      activeKey: "user"
    };
  }
  getHighlightDom() {
    const { text, users } = this.state;
    const input = text.replace("@", "").replace(/\\/g, "\\\\").trim();
    let newUsers = users.map((item: any) => {
      if (item.role === "user") {
        return {
          ...item,
          desc: getUnitTitleInfo(item.unitName, item.titleName)
        };
      }
      if (item.role === "dept") {
        return { ...item, desc: item.unitName };
      }
      return item;
    });
    if (input && input.length > 0) {
      newUsers = newUsers.map((item: any) => {
        let replaceReg = new RegExp(input, "g");
        let replaceString = `<span class="highlight-text">${input}</span>`;
        return {
          ...item,
          highName: item.name?.replace(replaceReg, replaceString),
          highAlias: item.alias?.replace(replaceReg, replaceString),
          hightDesc: item.desc?.replace(replaceReg, replaceString),
          highRemark: item.remark?.replace(replaceReg, replaceString)
        };
      });
    } else {
      newUsers = newUsers.map((item: any) => {
        return {
          ...item,
          highName: item.name,
          highAlias: item.alias,
          highRemark: item.remark,
          hightDesc: item.desc
        };
      });
    }
    return newUsers;
  }

  handleMentionKeyDown(e: React.KeyboardEvent<HTMLDivElement>, ok: Function) {
    // console.log('e', e, e.key, e.keyCode, (e as any).code, e.which);
    e.preventDefault();
    e.stopPropagation();
    // console.log('mention keydown', e.key);
    const key = e.keyCode === 32 ? "space" : e.key;
    ok(key);
  }
  getAvatar(user: any) {
    if (user.role === "all") {
      return <div className="all-avatar">@</div>;
    } else if (user.role === "user" || user.role === "robot") {
      return (
        <Avatar
          styleObj={{
            width: "24px",
            height: "24px",
            fontSize: "9px"
          }}
          src={user.avatar ? changeEgovUrl(getHeadImgThumbUrl(user.avatar, 150, 150)) : ""}
          className="avatarNoDraggable"
          name={user.name}
        />
      );
    } else {
      return (
        <div className="org-avatar">
          {/* <IconFont type="iconic_app_im_Architecture" /> */}
          <img
            src={
              user.role === "unit" ? unitAvatar : user.role === "dept" ? deptAvatar : titleAvatar
            }
          />
        </div>
      );
    }
  }

  getItem(list: any, robotList?: any) {
    const { selected, focusUser } = this.state;
    const { selectedSession } = this.props;
    if (list.length) {
      return list.map((user: any, index: number) => {
        return (
          <div
            key={index}
            className={`mention-list-item ${
              focusUser.id && focusUser.id === extraConvertEmployeeToString(user)
                ? "mention-list-item-focus"
                : ""
            }`}
            onClick={() => this.onUserSelect(user)}
          >
            <CheckBox
              className="mention-list-item-checkbox"
              checked={selected.includes(extraConvertEmployeeToString(user))}
              fillColor
            />

            <div className="avatar">{this.getAvatar(user)}</div>
            <div className="name-tag">
              <div
                className={`tag_name_alias ${
                  user.role === "user" || user.role === "dept" ? "tag_name_alias_user" : ""
                }`}
              >
                <div className="user_name" dangerouslySetInnerHTML={{ __html: user.highName }} />
                {user.role === "user" &&
                  (user.highRemark || (isShowAlias(selectedSession) && user.highAlias)) && (
                    <div className="user_alias">
                      <span>（</span>
                      <span
                        className="user_alias_content"
                        dangerouslySetInnerHTML={{
                          __html: `${user.highRemark || user.highAlias}`
                        }}
                      />
                      <span>）</span>
                    </div>
                  )}
                {user.role === "user" && tagsNode(user.labelInfoList)}
              </div>
              {user.role !== "all" && user.role !== "unit" && (
                <div className="descInfo">
                  <div
                    className="descInfo_content"
                    dangerouslySetInnerHTML={{
                      __html: user.hightDesc
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        );
      });
    } else {
      return robotList?.length > 0 ? null : <div className="mention-list-nodata">暂无数据</div>;
    }
  }
  getContent() {
    const { visible, onvisible, text, activeKey } = this.state;
    const newUsers = this.getHighlightDom();
    // console.log("newUsers", newUsers);
    const allList = newUsers.filter((item) => item.role === "all");
    const unitList = newUsers.filter((item) => item.role === "unit");
    const deptList = newUsers.filter((item) => item.role === "dept");
    const titleList = newUsers.filter((item) => item.role === "title");
    const memberList = newUsers.filter((item) => item.role === "user");
    const robotList = newUsers.filter((item) => item.role === "robot");
    return (
      <div
        className={onvisible || !visible ? "" : "editor-mention-container"}
        ref={this.ref_div}
        tabIndex={0}
        onKeyDown={(e) => this.handleMentionKeyDown(e, this.onKeyDown)}
      >
        {text === "" && (
          <div className="mention-tabs">
            <Tabs
              activeKey={activeKey}
              onChange={(activeKey) => {
                this.setState({ activeKey });
              }}
            >
              <Tabs.TabPane tab="人员" key="user" />
              <Tabs.TabPane tab="单位" key="unit" />
              <Tabs.TabPane tab="部门及职务" key="deptOrTitle" />
              <Tabs.TabPane tab="机器人" key="robot" />
            </Tabs>
          </div>
        )}
        <div className="mention-list">
          {(activeKey === "user" || text !== "") && (
            <>
              {text === "" && this.getItem(allList)}
              {this.getItem(memberList, robotList)}
            </>
          )}
          {(activeKey === "unit" || text !== "") && unitList.length ? this.getItem(unitList) : null}
          {(activeKey === "deptOrTitle" || text !== "") && (
            <>
              {text === "" && <div className="category-title">部门信息</div>}
              {deptList.length ? this.getItem(deptList) : null}
              {text === "" && <div className="category-title">职务信息</div>}
              {titleList.length ? this.getItem(titleList) : null}
            </>
          )}
          {(activeKey === "robot" || text !== "") && robotList.length
            ? this.getItem(robotList)
            : null}
        </div>
        <div className="at-footer-wrapper">
          <p className="tip-content">↑↓键-定位，空格键-选中，Enter键-确认</p>
          <Button className="cancel" size="small" onClick={() => this.userSelectCancel()}>
            取消
          </Button>
          <Button
            className="confirm"
            size="small"
            type="primary"
            onClick={() => this.userSelectOk()}
          >
            确定
          </Button>
        </div>
      </div>
    );
  }

  componentDidMount() {
    Bus.on("message:mentionUser", this.onMessageMention);
  }
  componentWillUnmount() {
    Bus.off("message:mentionUser", this.onMessageMention);
  }
  onMessageMention = (data: any) => {
    // this.props.editor.events.emit("close-mention");
    this.props.editor.insertText(" ");
    // this.setState({
    //   onvisible: true
    // });
    this.setState({ text: "" });
    // setTimeout(() => {
    // if (!isFocusEnv()) {
    //   this.setState({ visible: false });
    // }
    this.insertMentionLink(data);
    // }, 10);
    this.props.editor.focus();
  };

  // 选择用户 鼠标点击或者空格选中
  onUserSelect(user: any) {
    if (user?.userId === "all") {
      this.insertMentionLink([
        {
          id: extraConvertEmployeeToString(user),
          type: "user",
          name: user.name
        }
      ]);
      return;
    }
    const { selected } = this.state;
    const userString = extraConvertEmployeeToString(user);
    const idx = selected.indexOf(userString);
    if (idx > -1) {
      selected.splice(idx, 1);
    } else {
      selected.push(userString);
    }
    this.setState({
      selected
    });
  }
  userSelectCancel = () => {
    this.curRef?.hide();
    this.props.editor.focus();
  };

  // Enter操作并关闭弹框
  userSelectOk = () => {
    const { selected, users } = this.state;
    if (!selected.length) {
      this.userSelectCancel();
      return;
    }
    let selectedUsers = users.filter((user) => {
      return selected.includes(extraConvertEmployeeToString(user));
    });
    const { selectedSession } = this.props;

    const insertUsers = selectedUsers.map((user: any) => {
      const alias = isShowAlias(selectedSession) ? user.alias : "";
      return {
        id: extraConvertEmployeeToString(user),
        type: "user",
        name: user.name,
        alias: alias,
        remark: user.remark,
        app: user.app,
        pin: user.userId,
        teamId: user.teamId
      };
    });
    // if (!isFocusEnv()) {
    this.setState({
      visible: false
    });
    // }
    setTimeout(() => {
      this.insertMentionLink(insertUsers);
    }, 10);
    this.props.editor.focus();
  };

  insertMentionLink(values: any) {
    const { editor } = this.props;
    const ua = navigator.userAgent.toLowerCase();
    const testUa = (regexp: RegExp) => regexp.test(ua);
    if (testUa(/safari/g)) {
      editor.focus();
    }
    const range = editor.getSelection();
    if (!range) return;
    const { index } = range;
    const quill = editor.getQuill();
    if (!quill) return;
    const Delta = Quill.import("delta");
    const inputLen = this.state.text.length + 1;
    const deltaObj = new Delta().retain(index - inputLen).delete(inputLen);
    values.forEach((value: any) => {
      deltaObj.insert({
        "mention-link": value
      });
    });
    quill.updateContents(deltaObj, "user");
    try {
      // if (!isFocusEnv()) {
      const currentRange = quill.getSelection();
      const { index: currentIndex } = currentRange;
      quill.insertText(currentIndex, " ");
      // } else {
      // quill.insertText(index + values.length - 1, ' ');
      // }
    } catch (e) {
      console.log("网页版@成员后插入空格报错", e);
    }

    this.setState({ text: "" });
    if (this.curRef) {
      this.curRef.hide();
    }
    if (this.state.onvisible) {
      this.setState({ onvisible: false });
    }
  }

  scrollList() {
    const ele = document.querySelector<HTMLDivElement>(
      ".editor-mention-container .mention-list-item-focus"
    );
    if (ele) {
      ele.scrollIntoView({
        block: "end",
        inline: "end"
      });
    }
  }

  onKeyDown = (key: string) => {
    const { users, focusUser, activeKey, text } = this.state;
    if (!users.length) return;
    // const idx = this.state.users.findIndex((user) => {
    //     return this.state.selected.includes(convertEmployeeToString(user as Employee));
    // });
    const allList = users.filter((item: any) => item.role === "all");
    const unitList = users.filter((item: any) => item.role === "unit");
    const deptOrTitleList = users.filter(
      (item: any) => item.role === "dept" || item.role === "title"
    );
    const memberList = users.filter((item: any) => item.role === "user");
    const robotList = users.filter((item: any) => item.role === "robot");
    const list =
      text !== ""
        ? [...memberList, ...unitList, ...deptOrTitleList, ...robotList]
        : activeKey === "user"
        ? [...allList, ...memberList]
        : activeKey === "unit"
        ? unitList
        : activeKey === "deptOrTitle"
        ? deptOrTitleList
        : robotList;
    // console.log("onKeyDown", list);
    const idx = list.findIndex((user) => {
      return focusUser.id && focusUser.id === extraConvertEmployeeToString(user);
    });
    let nIdx = idx;
    if (text !== "" && (key === "ArrowLeft" || key === "ArrowRight")) {
      return;
    }
    const tabs = ["user", "unit", "deptOrTitle", "robot"];
    const tabIdx = tabs.findIndex((tab) => tab === activeKey);
    let nTabIdx = tabIdx;
    // console.log('keyDown', key);
    switch (key) {
      case "ArrowUp":
        nIdx = idx - 1;
        if (nIdx < 0) {
          nIdx = list.length - 1;
        }
        break;
      case "ArrowDown":
        nIdx = idx + 1;
        if (nIdx > list.length - 1) {
          nIdx = 0;
        }
        break;
      case "ArrowLeft":
        nTabIdx = tabIdx - 1;
        if (nTabIdx < 0) {
          nTabIdx = tabs.length - 1;
        }
        break;
      case "ArrowRight":
        nTabIdx = tabIdx + 1;
        if (nTabIdx > tabs.length - 1) {
          nTabIdx = 0;
        }
        break;
      case "Enter":
        this.userSelectOk();
        break;
      case "space":
        if (focusUser.id) {
          this.onUserSelect(focusUser);
        }
        break;
      default:
        break;
    }
    // console.log('nIdx----', nIdx);
    // console.log('下标', nIdx, users[nIdx]);
    this.setState(
      {
        // selected: [convertEmployeeToString(users[nIdx] as Employee)] || [],
        focusUser:
          (nIdx > -1 && { ...list[nIdx], id: extraConvertEmployeeToString(list[nIdx]) }) || {},
        activeKey: tabs[nTabIdx] || "user"
      },
      () => {
        this.scrollList();
      }
    );
  };

  onTextInput = async (text: string) => {
    const input = text.replace("@", "").trim();
    // console.log('textinput', input);
    const result = await this.props.handleSearch(input);
    console.log("handleSearch-result:", result);
    this.setState({
      text: input
    });
    if (this.ref_div.current) {
      this.ref_div.current.scrollTop = 0;
    }
    const { selected } = this.state;
    if (result.length === 0) {
      this.setState({
        users: [],
        selected: [],
        focusUser: {},
        // visible: false,
        text: ""
      });
      // this.onVisibleChange(false);
      this.curRef?.setKeyPrevent(false);
      return;
    }
    this.curRef?.setKeyPrevent(true);
    let tempUser = {};
    if (result.length === 1) {
      tempUser = result[0];
    } else {
      tempUser = {};
    }
    this.setState({
      users: result,
      selected: selected,
      onvisible: false,
      focusUser: { ...tempUser, id: extraConvertEmployeeToString(tempUser) }
    });
  };

  onVisibleChange = (visible: boolean) => {
    this.props.onVisibleChange?.(visible);
    if (!visible) {
      // console.log('关闭');
      this.setState({
        users: [],
        selected: [],
        focusUser: {},
        visible: false,
        activeKey: "user"
      });
      setTimeout(() => {
        this.setState({ text: "" });
      }, 100);
    } else {
      // console.log('为true');
      const users = this.props.handleSearch("");
      const { selectedSession, groupMemberSessionId } = this.props;
      // const { focusUser } = this.state;
      const needShow =
        selectedSession.isSingle ||
        (selectedSession.isGroup && selectedSession.sessionId === groupMemberSessionId);
      if (users.length > 0 && needShow) {
        this.curRef?.setKeyPrevent(true);
        this.setState({
          visible: true,
          selected: [],
          users,
          focusUser: {},
          activeKey: "user"
        });
      }
    }
  };

  render() {
    const { visible, users, onvisible } = this.state;
    const { isQuillModal } = this.props;
    // const onlyAllUser = users.length === 1 && users[0].userId === 'all';
    return (
      <div className={onvisible === true ? "ismention" : ""}>
        <div
          className={`chat-mention ${visible && users.length ? "" : "chat-mention-hidden"} ${
            isQuillModal ? "quill-modal" : ""
          }`}
        >
          {/* {!onlyAllUser && this.getContent()} */}
          {this.getContent()}
        </div>
        <CursorPopover
          ref={(ref) => {
            this.curRef = ref;
          }}
          bindings={["@"]}
          editor={this.props.editor}
          content={null}
          onKeyDown={this.onKeyDown}
          onTextInput={this.onTextInput}
          onVisibleChange={debounce(this.onVisibleChange, 300)}
          withoutPopover={true}
          visible={visible}
        />
      </div>
    );
  }
}

function mapStateToProps({ chat }: any) {
  const { selectedSession, currentEmployee, groupMemberSessionId } = chat as ChatState;
  return { selectedSession, currentEmployee, groupMemberSessionId };
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(MentionUserPlugin);
